/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface StationRegistrationStatusDto
 */
export interface StationRegistrationStatusDto {

    /**
     * @type {number}
     * @memberof StationRegistrationStatusDto
     */
    id: number;

    /**
     * @type {string}
     * @memberof StationRegistrationStatusDto
     */
    status: StationRegistrationStatusDtoStatusEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum StationRegistrationStatusDtoStatusEnum {
    Registered = 'registered',
    Updated = 'updated',
    AlreadyRegistered = 'already_registered'
}

